import * as React from 'react';
const SvgSquareInsetCenterDashed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.528 4.167c-.752 0-1.361.61-1.361 1.36v1.167a.583.583 0 1 1-1.167 0V5.528A2.53 2.53 0 0 1 5.528 3h1.166a.583.583 0 1 1 0 1.167zM6.85 8.639c0-.967.784-1.75 1.75-1.75h2.722c.967 0 1.75.783 1.75 1.75v2.722a1.75 1.75 0 0 1-1.75 1.75H8.6a1.75 1.75 0 0 1-1.75-1.75zm1.75-.583a.583.583 0 0 0-.583.583v2.722c0 .322.26.583.583.583h2.722a.583.583 0 0 0 .584-.583V8.64a.583.583 0 0 0-.584-.583zm5.872-3.89c.752 0 1.361.61 1.361 1.362v1.166a.583.583 0 0 0 1.167 0V5.528A2.53 2.53 0 0 0 14.472 3h-1.166a.583.583 0 1 0 0 1.167zm0 11.667c.752 0 1.361-.61 1.361-1.36v-1.167a.583.583 0 0 1 1.167 0v1.166A2.53 2.53 0 0 1 14.472 17h-1.166a.583.583 0 1 1 0-1.167zm-8.944 0c-.752 0-1.361-.61-1.361-1.36v-1.167a.583.583 0 1 0-1.167 0v1.166A2.53 2.53 0 0 0 5.528 17h1.166a.583.583 0 0 0 0-1.167z"
    />
  </svg>
);
export default SvgSquareInsetCenterDashed;
